// SVG wave divider — water brand motif between sections.
export const WaveDivider = ({ flip = false, fill = '#0B1220', className = '' }) => (
  <div className={`relative w-full leading-[0] ${className}`} style={{ transform: flip ? 'rotate(180deg)' : 'none' }} aria-hidden="true">
    <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="w-full h-[60px] sm:h-[90px] block">
      <path
        fill={fill}
        d="M0,64 C240,120 480,8 720,40 C960,72 1200,120 1440,72 L1440,120 L0,120 Z"
      />
    </svg>
  </div>
);

export default WaveDivider;
